import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/CheckCircle'; 
import CancelIcon from '@mui/icons-material/Cancel'; 
import { MentorType } from '../../utils/constant';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
// Consolidated status colors and text mapping based on constants.js and ProfileView
export const WCAG_COLORS = {
  yellow: "var(--color-yellow-wcag, #946800)", //replaced hex code #FFD500
  yellowBg: "var(--color-yellow-bg-wcag, #FFF6D1)", //replaced hex code #FFFBE9
  orange: "var(--color-orange-wcag, #c15000)", //replaced hex code #FF7600
  green: "var(--color-green-wcag, #0d6e51)", //replaced hex code #16B681
  greenBg: "var(--color-green-bg-wcag, #E5FFF7)", //replaced hex code #E6F4ED
  darkGreen: "var(--color-dark-green-wcag, #0d6e51)", //replaced rgba(235, 255, 243, 1)
  darkGreenBg: "var(--color-dark-green-bg-wcag, #E5FFF7)", //replaced rgba(22, 182, 129, 1)
  red: "var(--color-red-wcag, #d03127)",  // replaced hex code #E0382D
  redBg: "var(--color-red-bg-wcag, #FEF0F3)", //replaced hex code #FFF0F4
  darkRed: "var(--color-dark-red-wcag, #b00020)", //replaced rgba(255, 231, 231, 1)
  darkRedBg: "var(--color-dark-red-bg-wcag, #FEF0F3)", //replaced rgba(255, 231, 231, 1)
  skyblue: "var(--color-skyblue-wcag, #00818A)", //replaced hex code #00aebd, rgba(0, 174, 189, 1)
  lightGrayBg: "var(--color-light-gray-bg-wcag, #EFF4F5)", //replaced rgba(238, 240, 244, 1)
};

export const statusColors = {
  // Request status colors
  new: "#1D5BBF",
  pending: WCAG_COLORS.yellow,
  waiting_mentor: "#1D5BBF",
  completed: WCAG_COLORS.green,
  cancelled: WCAG_COLORS.red,
  incomplete: WCAG_COLORS.red,
  rejected: WCAG_COLORS.red,
  approved: WCAG_COLORS.green,
  assigned: WCAG_COLORS.green,
  checked_in: WCAG_COLORS.green,
  checked_out: "#2563EB",
  check_in_pending: WCAG_COLORS.yellow,
  check_out_pending: WCAG_COLORS.orange,
  missed_check_in: WCAG_COLORS.red,
  accept: WCAG_COLORS.green,
  in_progress: "#FF7600",
  inreview: "#FF7600",
  acccepted: WCAG_COLORS.green,
  Reviewed:"#FF7600", 
  corrected: WCAG_COLORS.green,
  no_correction_needed: "#6E6E6E",
  priority_low: WCAG_COLORS.green,
  priority_medium: WCAG_COLORS.yellow,
  priority_high: WCAG_COLORS.red,
  priority_unassigned: "#6E6E6E",
  severity_critical: WCAG_COLORS.red,
  severity_non_critical: "#6E6E6E",
  // Program statuses
  yettojoin: "#1D5BBF",
  yettostart: WCAG_COLORS.yellow,
  yettoaccept: WCAG_COLORS.yellow,
  yettoapprove: WCAG_COLORS.yellow,
  inprogress: WCAG_COLORS.orange,
  started: WCAG_COLORS.orange,
  paused: WCAG_COLORS.red,
  draft: "#6E6E6E",
  assign_program_accepted: WCAG_COLORS.green,
  new_program_request_rejected: WCAG_COLORS.red,
  
  // Assignment status colors
  waiting_for_approval: "#1D5BBF",
  reassigned: "#1D5BBF",
  newtask: "#1D5BBF",
  submitted: WCAG_COLORS.yellow,
  draft_val: WCAG_COLORS.yellow,
  sent: WCAG_COLORS.green,
  // Step statuses
  "In-Progress"  : "#FF7600",
  "In Progress" :"#FF7600",
  "Waiting": WCAG_COLORS.yellow,
  "Completed": WCAG_COLORS.green,
  "Not Started":"#6E6E6E",
  
  // Goal statuses
  active: WCAG_COLORS.yellow,
  ongoing: "#FF7600",
  aborted: WCAG_COLORS.red,
  inactive: "#FF7600",
  decline: WCAG_COLORS.red,
  cancel: WCAG_COLORS.red,
  
  // Member statuses
  "Active": WCAG_COLORS.green,    // Same color as "new"
  "Deactive": WCAG_COLORS.red,  // Same color as "cancelled"
  "Inactive": WCAG_COLORS.red,
  "Pending": WCAG_COLORS.yellow,
  
  // Other statuses
  Wating_for_response: "#1D5BBF",
  launched: WCAG_COLORS.green,
  deactivated: "#6E6E6E",
  review: "#1D5BBF",
  deleted: WCAG_COLORS.red,
  
  // ProfileView specific statuses
  "Approved": WCAG_COLORS.green,
  "Rejected": WCAG_COLORS.red,
  "Assigned": WCAG_COLORS.green,
  
  // For not submitted status
  "Not Submitted": "#6E6E6E",

  // equipment status
  inuse: "#FE634E",
  available: WCAG_COLORS.green,
  maintenance: WCAG_COLORS.orange,
  under_maintenance: WCAG_COLORS.orange,
  scheduled: WCAG_COLORS.yellow,
  overdue: WCAG_COLORS.red,
  due_soon: WCAG_COLORS.yellow,
  on_time: WCAG_COLORS.green,
  // eslint-disable-next-line no-dupe-keys
  deactivated: "#BF453A",
  archived: "#4F4F4F",
   // InterviewStatus choices from backend
   mail_sent: WCAG_COLORS.green,
   selected: "#1D5BBF",
   not_selected: WCAG_COLORS.red,
 
   // BackgroundCheckStatus choices from backend
   not_started: "#1D5BBF",
   passed: WCAG_COLORS.green,
   failed: WCAG_COLORS.red,
   ERROR: WCAG_COLORS.red,
   FAILURE: WCAG_COLORS.red,
   SUCCESS: WCAG_COLORS.green,
 
   // TrainingVideoStatus choices from backend
   yet_to_watch: WCAG_COLORS.yellow,
   watched: WCAG_COLORS.green,
 
   // ApplicationStatus choices from backend
   waiting_for_verification: WCAG_COLORS.yellow,
   verified: WCAG_COLORS.green,
};

// Comprehensive text mapping based on constants.js and ProfileView
export const statusText = {
  // Request status texts
  new: "New",
  pending: "Pending",
  waiting_mentor: `Waiting ${MentorType}`,
  completed: "Completed",
  cancelled: "Cancelled",
  rejected: "Rejected",
  approved: "Approved",
  assigned: "Assigned",
  checked_in: "Checked In",
  checked_out: "Checked Out",
  check_in_pending: "Check-in Pending",
  check_out_pending: "Check-out Pending",
  missed_check_in: "Missed Check-in",
  accept: "Approved",// goal 
  in_progress: "In Progress",
  inreview: "In Review",
  incomplete: "In Complete",
  Reviewed:"Reviewed", 
  corrected: "Corrected",
  no_correction_needed: "No Correction Needed",
  priority_low: "Low",
  priority_medium: "Medium",
  priority_high: "High",
  priority_unassigned: "Not Assigned",
  severity_critical: "Critical",
  severity_non_critical: "Non Critical",
  draft_val:"Draft",
  sent: "Sent",
  
  // Program status texts
  yettojoin: "Yet to Launch",
  yettostart: "Yet to Start", 
  yettoapprove: "Waiting for Approval",
  inprogress: "Ongoing",
  started: "Ongoing",
  paused: "Paused",
  draft: "Draft",
  assign_program_accepted: "Approved",
  new_program_request_rejected: "Rejected",
  
  // Assignment status texts
  waiting_for_approval: "Waiting for Approval",
  reassigned: "Re-assigned",
  newtask: "New",
  submitted: "Submitted",
  
  // Step statuses
  "In-Progress": "In Progress",
  "Waiting": "Waiting",
  
  // Goal statuses
  active: "Active",
  ongoing: "Ongoing",
  aborted: "Aborted",
  inactive: "Inactive",
  decline: "Declined",
  cancel: "Cancelled",
  
  // Member statuses
  "Active": "Active",
  "Deactive": "Deactive",
  "Inactive": "Inactive",
  
  // Other statuses
  Wating_for_response: "Waiting for Response",
  launched: "Launched",
  deactivated: "Deactivated",
  review: "Review",
  deleted: "Deleted",
  
  // ProfileView specific statuses
  "Approved": "Approved",
  "Rejected": "Rejected",
  "Assigned": "Assigned",
  
  // For not submitted status
  "Not Submitted": "Not Submitted",
  "acccepted": "Accepted",
  "yettoaccept": "Yet To Accept",
    // InterviewStatus choices from backend
    mail_sent: "Mail Sent",
    selected: "Selected",
    not_selected: "Not Selected",
  
    // BackgroundCheckStatus choices from backend
    not_started: "Not Started",
    passed: "Passed",
    failed: "Failed",
    ERROR: "Error",
    FAILURE: "Failure",
    SUCCESS: "Success",
  
    // TrainingVideoStatus choices from backend
    yet_to_watch: "Yet to Watch",
    watched: "Watched",
  
    // ApplicationStatus choices from backend
    waiting_for_verification: "Waiting for Verification",
    verified: "Verified",

    // Equipment status
    inuse: "In Use",
    available: "Available",
    maintenance: "Maintenance",
    under_maintenance: "Under Maintenance",
    scheduled: "Scheduled",
    overdue: "Overdue",
    due_soon: "Due Soon",
    on_time: "Completed",
    archive: "Archive",
    // eslint-disable-next-line no-dupe-keys
    deactivated: "Deactivated",
    archived: "Archive",
};

export const statusWithIcons = {
  "Approved": VerifiedIcon,
  "Rejected": CancelIcon,
  "approved": VerifiedIcon,
  "rejected": CancelIcon,
  "accept": VerifiedIcon,
  "cancel": CancelIcon,
  "passed": VerifiedIcon,
  "failed": CancelIcon,
  "verified": VerifiedIcon,
};

/**
 * StatusIndicator component for displaying status with colored dot or icon
 * 
 * @param {Object} props - Component props
 * @param {string} props.status - Status value (e.g. 'new', 'pending', etc.)
 * @param {boolean} props.useIcon - Whether to use icons instead of dots for certain statuses
 * @param {Object} props.sx - Optional MUI sx props for additional styling
 * @returns {JSX.Element} Status indicator with dot/icon and text
 */
const StatusIndicator = ({ status, useIcon = false, sx = {} }) => {
  const statusColor = statusColors[status] || "#6E6E6E"; // Default gray if status not found
  const displayText = statusText[status] || status; // Use mapping or the status itself
  const showDot = status !== "Not Submitted"; // Don't show dot for "Not Submitted"
  const IconComponent = useIcon && statusWithIcons[status];

  return status ? (
    <Stack 
      direction="row" 
      alignItems="center" 
      spacing={1}
      sx={sx}
    >
      {showDot && !IconComponent && (
        <Box
          className="h-[10px] w-[10px] rounded-full"
          sx={{
            background: statusColor,
          }}
        />
      )}
      
      {showDot && IconComponent && (
        <IconComponent 
          sx={{ 
            color: statusColor,
            fontSize: "1.2rem"
          }} 
        />
      )}
      
      <Typography
        className={`!text-[14px] ${useIcon ? 'font-medium' : 'font-medium'}`}
        sx={{
          color: statusColor,
        }}
      >
        {displayText}
      </Typography>
    </Stack>
  ) : (
    <MoreHorizIcon />
  );
};

/**
 * StatusIndicatorWithAction component extends StatusIndicator to include optional action elements
 * 
 * @param {Object} props - Component props
 * @param {string} props.status - Status value (e.g. 'new', 'pending', etc.)
 * @param {boolean} props.useIcon - Whether to use icons instead of dots
 * @param {React.ReactNode} props.action - Optional action element to show alongside status
 * @param {Object} props.sx - Optional MUI sx props for additional styling
 * @returns {JSX.Element} Status indicator with action
 */
export const StatusIndicatorWithAction = ({ status, useIcon = false, action, sx = {} }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={sx}
    >
      <StatusIndicator status={status} useIcon={useIcon} />
      {action}
    </Stack>
  );
};

export default StatusIndicator;